import React from "react";
import { Button } from "@material-ui/core";

import { Token } from "../../types";

import { PopupButtonsContainer, PopupContainer, PopupDescription, PopupTitle } from "../../common.styles";

interface SuccessProps {
    onConfirm: () => void,
    selectedToken: Token
}

const Success = ({ onConfirm, selectedToken }: SuccessProps) => {
    return (
        <PopupContainer>
            <PopupTitle>{selectedToken.count} {selectedToken.count <= 1 ? 'token' : 'tokens'} purchased</PopupTitle>
            <PopupDescription>
                The Tokens have been added to your account. They never expire, and you only spend a token to view an Applicant's resumé for the first time.
            </PopupDescription>
            <PopupButtonsContainer>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    color="primary"
                    size="large"
                    id="review-button"
                    className="bigButtonInNewStyle"
                >
                    OK
                </Button>
            </PopupButtonsContainer>
        </PopupContainer>
    );
}

export default Success;
